import { z } from 'zod';

export const userProfileValidation = z.object({
  email: z.string(),
  file: z.string().optional(),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().optional(),
  phone: z.string().optional(),
  postalCode: z.string().optional(),
});
